module.exports = __webpack_public_path__ + "images/icons/icon-payments-a04cad75.svg";